import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { mix } from 'polished';
import styled from 'styled-components';
const Container = styled.ul `
  display: flex;
`;
const Item = styled.li `
  display: flex;
  flex: 1 1 50%;
`;
const Button = styled.button `
  ${ButtonReset}
  ${transition('background-color, color, opacity')}

  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${fluid(16, 20)} ${fluid(20, 24)} ${fluid(24, 36)};
  text-align: center;
  width: 100%;

  > span {
    display: block;

    /* @todo: uncomment when new finance product is launched */
    /* &:first-child {
      ${fonts.brandonGrotesque.bold}

      font-size: ${fluid(14, 16)};
      line-height: 1em;
      margin-bottom: ${fluid(8, 2)};
      text-transform: uppercase;
    } */

    &:last-child {
      ${fonts.zahrah.medium}

      font-size: ${fluid(20, 30)};
      line-height: 1em;
    }
  }

  ${Item}[data-active="false"] & {
    @media ${until(Device.TabletLarge)} {
      background: ${mix(0.6, brand.white, brand.green)};

      > span {
        &:first-child {
          color: ${brand.green};
        }

        &:last-child {
          color: ${brand.black};
        }
      }
    }

    @media ${from(Device.TabletLarge)} {
      background: ${brand.green};
      opacity: 0.6;

      > span {
        &:first-child {
          color: ${brand.white};
        }

        &:last-child {
          color: ${brand.white};
        }
      }

      &:focus,
      &:hover {
        opacity: 1;
      }
    }
  }

  ${Item}[data-active="true"] & {
    background: ${brand.white};
    opacity: 1;

    > span {
      &:first-child {
        color: ${brand.green};
      }

      &:last-child {
        color: ${brand.black};
      }
    }
  }
`;
const TabListStyles = {
    Button,
    Container,
    Item,
};
export default TabListStyles;
